(() => {
  if (customElements.get('number-count')) {
    return;
  }

  class NumberCount extends HTMLElement {
    constructor() {
      super();
      this.elements = this.querySelectorAll('[data-element]');
    }

    connectedCallback() {
      this.elements.forEach((element) => {
        this.start(element);
      });
    }

    start(element) {
      const counter = new CountUp(element, element.dataset.number, {
        duration: 5,
        decimalPlaces: element.textContent.includes('.') ? 1 : 0,
        enableScrollSpy: true,
        scrollSpyOnce: true,
      });

      counter.start();
    }
  }

  customElements.define('number-count', NumberCount);
})();
